var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStaffManagementSvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/tag-user"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tag-user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 19.36H17.24C16.44 19.36 15.68 19.67 15.12 20.23L13.41 21.92C12.63 22.69 11.36 22.69 10.58 21.92L8.87 20.23C8.31 19.67 7.54 19.36 6.75 19.36H6C4.34 19.36 3 18.03 3 16.39V5.47C3 3.83 4.34 2.5 6 2.5H18C19.66 2.5 21 3.83 21 5.47V16.38C21 18.02 19.66 19.36 18 19.36Z",
    stroke: "#FFC051",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.0701 9.45005C12.0301 9.45005 11.97 9.45005 11.92 9.45005C10.87 9.41005 10.04 8.56005 10.04 7.50005C10.04 6.42005 10.9101 5.55005 11.9901 5.55005C13.0701 5.55005 13.9401 6.43005 13.9401 7.50005C13.9501 8.56005 13.1201 9.42005 12.0701 9.45005Z",
    stroke: "#FFC051",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.25043 12.4601C7.92043 13.3501 7.92043 14.8001 9.25043 15.6901C10.7604 16.7001 13.2404 16.7001 14.7504 15.6901C16.0804 14.8001 16.0804 13.3501 14.7504 12.4601C13.2404 11.4601 10.7704 11.4601 9.25043 12.4601Z",
    stroke: "#FFC051",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffManagementSvg);
export default __webpack_public_path__ + "static/media/StaffManagementSvg.23fc38d94071c15e4e92b4f3f63d4632.svg";
export { ForwardRef as ReactComponent };